import generateUUID from 'utils/sharedUtils/generateUUID';

type BuildDraftSitrepPayloadParams = {
  scopeName: string;
  aorId?: string | null;
  incidentId?: string;
};

const USCG_DEFAULT_TEMPLATE_ID = '11111111-1111-1111-1111-111111111111';

export const buildDraftSitrepPayload = ({
  scopeName,
  aorId,
  incidentId,
}: BuildDraftSitrepPayloadParams) => ({
  skip_default_sections: false,
  sitrep_template_id: USCG_DEFAULT_TEMPLATE_ID,
  sitrep_source: 'reports',
  sitrep_source_id: generateUUID(),
  name: `SITREP for ${scopeName}`,
  description: '',
  selectedDatetime: new Date().toISOString(),
  aor_id: aorId || undefined,
  incident_id: incidentId || undefined,
  is_sitrep: true,
});
